import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StructuredDataService } from '@core/services/structured-data.service';
import { environment } from '@env';
import { FooterComponent } from './component/footer/footer.component';
import { HeaderComponent } from './component/header/header.component';

@Component({
  selector: 'fc-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
})
export class LayoutComponent {
  private readonly structuredData = inject(StructuredDataService);

  constructor() {
    this.injectGlobalStructuredData();
  }

  private injectGlobalStructuredData(): void {
    const site = environment.SITE_URL.replace(/\/+$/, '');
    const logo = `${site}/assets/images/logo/logo.webp`;

    this.structuredData.setLd(
      'organization',
      {
        '@context': 'https://schema.org',
        '@type': ['Organization', 'LocalBusiness'],
        '@id': `${site}/#organization`,
        name: 'PT Glori Global Makmur',
        url: `${site}/`,
        logo,
        image: logo,
        description:
          'General supplier dan hardware di Batam untuk peralatan las, alat keselamatan kerja, material konstruksi, peralatan listrik, pipa dan katup.',
        email: 'info@gloriglobalmakmur.com',
        telephone: '+6281374168889',
        address: {
          '@type': 'PostalAddress',
          streetAddress:
            'BCI Industrial Park Blok B No. 12, Tanjung Sengkuang, Batu Ampar',
          addressLocality: 'Batam',
          addressRegion: 'Kepulauan Riau',
          postalCode: '29444',
          addressCountry: 'ID',
        },
        contactPoint: [
          {
            '@type': 'ContactPoint',
            contactType: 'sales',
            telephone: '+6281374168889',
            email: 'info@gloriglobalmakmur.com',
            availableLanguage: ['Indonesian'],
          },
        ],
      },
      { persistent: true }
    );

    this.structuredData.setLd(
      'website',
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'PT Glori Global Makmur',
        url: `${site}/`,
        inLanguage: 'id-ID',
        publisher: { '@id': `${site}/#organization` },
        potentialAction: {
          '@type': 'SearchAction',
          target: `${site}/product?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      { persistent: true }
    );
  }
}
